// extracted by mini-css-extract-plugin
export default {"search":"styles_search__a1aa7","search__icon":"styles_search__icon__GvCM1","search__crossIcon":"styles_search__crossIcon__Skrit"};